import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { AppInsightsErrorType } from "../../shared/insights/app-insights.consts";
import { sendAppInsightsServerError } from "../../shared/insights/app-insights.utils";
import { GATEWAY_API, DASH_API } from "../../shared/url.consts";
import { LoanOffer } from "../../types/loan-offer";

export interface FetchLoanOfferParams {
  quoteId: string;
  useNewEndpoint?: boolean;
}

export const returnLoanOffer = async (quoteId: string) => {
  return axios.get<LoanOffer>(`${GATEWAY_API}/loan-offer?quoteId=${quoteId}`);
};

export const returnLoanOfferFromDashApi = async (quoteId: string) => {
  return axios.get<LoanOffer>(`${DASH_API}/RateEstimate/${quoteId}/loan-offer`);
};

export const returnLoanOfferResponse = async ({
  quoteId,
  useNewEndpoint = false,
}: FetchLoanOfferParams) => {
  try {
    const response = useNewEndpoint
      ? await returnLoanOfferFromDashApi(quoteId)
      : await returnLoanOffer(quoteId);
    if (response.status === 200) {
      return response.data;
    } else {
      sendAppInsightsServerError(
        `non 200 response received from ${
          useNewEndpoint ? "DASH_API" : "GATEWAY_API"
        }: ${response}`,
        AppInsightsErrorType.LOAN_OFFER
      );
      return;
    }
  } catch (err) {
    sendAppInsightsServerError(
      `error fetching loan offer from ${
        useNewEndpoint ? "DASH_API" : "GATEWAY_API"
      }: ${err}`,
      AppInsightsErrorType.LOAN_OFFER
    );
  }
};

export const fetchLoanOffer = createAsyncThunk(
  "loan-offer/get",
  (params: string | FetchLoanOfferParams) => {
    // Normalize params to support backward compatibility
    const normalizedParams: FetchLoanOfferParams =
      typeof params === "string"
        ? { quoteId: params, useNewEndpoint: false }
        : params;

    return returnLoanOfferResponse(normalizedParams);
  }
);
